import { styled } from '@vr/ds-react'

export const BoxHeader = styled('div', {
  backgroundColor: '$neutralLight',
  borderRadius: '$borderRadiusSmall',
  fontSize: '$extraSmall',
  fontWeight: '$semiBold',
  lineHeight: '$extraLarge',
  padding: '$sm16'
})

export const BoxContent = styled('div', {
  backgroundColor: '$neutralVeryLight',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '$neutralMedium',
  borderRadius: '$borderRadiusSmall',
  fontSize: '$extraSmall',
  fontWeight: '$semiBold',
  lineHeight: '$extraLarge',
  padding: '$sm16',
  marginBottom: '$sm24'
})

export const BoxRounded = styled('div', {
  margin: '0',
  padding: '0',
  borderRadius: '$borderRadiusSmall',
  overflow: 'hidden'
})
